import { useEffect, useState } from "react";

export enum DeviceSize {
    Mobile = "Mobile",
    Desktop = "Desktop",
}

export default function useDeviceSize() {
    const [deviceSize, setDeviceSize] = useState(DeviceSize.Mobile);

    function getDeviceState(width: number) {
        if (width < 700) {
            return DeviceSize.Mobile;
        }
        return DeviceSize.Desktop;
    }

    useEffect(() => {
        if (window == undefined) return;
        setDeviceSize(getDeviceState(window.innerWidth))
        window.addEventListener("resize", () => {
            setDeviceSize(getDeviceState(window.innerWidth));
        });
        return () => {
            window.removeEventListener("resize", () => {
                setDeviceSize(getDeviceState(window.innerWidth));
            });
        }
    }, []);

    return deviceSize;
}